import type { ReactNode } from 'react';
import { VisuallyHidden as VH } from 'radix-ui';

export default function VisuallyHidden({ children }: { children: ReactNode }) {
  return <VH.Root>{children}</VH.Root>;
}
